module.exports = __webpack_public_path__ + "img/login_Premuim.43bae0ed.svg";